import Vue from 'vue'
import App from './App.vue'
import VueMoment from 'vue-moment';
import store from '../src/store/index'
import router from './routes/router'
import vuetify from './plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.use(VueMoment);
new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
